import React from 'react';
import type { SkeletonFrameProps } from './styled';
import { SkeletonFrame } from './styled';

export const SkeletonText: React.FC<SkeletonFrameProps> = props => {
  return <SkeletonFrame {...props} />;
};
